/**
 * 모바일 리스트 더보기 (fragments/mobile/list-more.html) — 관리모드 M6 batch-suit-group 의 계약 이식.
 *   1) 서버가 초기 N건 + data-total 을 렌더
 *   2) [더보기] → GET data-url?{검색폼 FormData}&offset={loaded} → 행 fragment HTML 반환
 *   3) data-container 에 insertAdjacentHTML('beforeend'), loaded 는 DOM 의 .data-row 개수로 재집계
 * 세션 만료 시 인터셉터가 /m/login 으로 302 → fetch 는 로그인 HTML 을 200 으로 받으므로 res.redirected 를 보고 로그인으로 이동(주입 방지).
 *
 * 루트 요소 data-*: total · url · form(검색 폼 id, 선택) · container(행 컨테이너 id) · row(행 클래스)
 */
export default () => ({
    total: 0,
    loaded: 0,
    loading: false,
    _cfg: {},

    init() {
        // $el 은 메서드 안에서 호출 요소로 바뀔 수 있어 루트 data-* 는 init 에서 캡처(project_alpine_css_traps)
        this._cfg = { ...this.$el.dataset };
        this.total = parseInt(this._cfg.total || '0');
        this.recount();
    },

    recount() {
        this.loaded = document.querySelectorAll('.' + this._cfg.row).length;
    },

    async loadMore() {
        if (this.loading) return;
        this.loading = true;
        const params = new URLSearchParams();
        const form = this._cfg.form ? document.getElementById(this._cfg.form) : null;
        if (form) {
            for (const [k, v] of new FormData(form).entries()) params.append(k, v);
        }
        params.set('offset', this.loaded);
        try {
            const res = await fetch(this._cfg.url + '?' + params.toString(), {
                headers: { 'X-Requested-With': 'fetch' }
            });
            if (res.redirected) { window.location.href = '/m/login'; return; }
            if (!res.ok) throw new Error('HTTP ' + res.status);
            const html = await res.text();
            document.getElementById(this._cfg.container).insertAdjacentHTML('beforeend', html);
            this.recount();
        } catch (e) {
            window.dispatchEvent(new CustomEvent('show-toast', {
                detail: { type: 'error', title: '오류', message: '목록을 불러오지 못했습니다.' }
            }));
        } finally {
            this.loading = false;
        }
    }
});
